'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
require('../style-222d2b0f.js');
var span = require('../typography/span.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: ", ";\n  color: ", ";\n  ", ";\n  text-decoration: ", ";\n  &:hover {\n    color: ", ";\n    ", ";\n    text-decoration: ", ";\n  }\n  ", ";\n"], ["\n  display: ", ";\n  color: ", ";\n  ", ";\n  text-decoration: ", ";\n  &:hover {\n    color: ", ";\n    ", ";\n    text-decoration: ", ";\n  }\n  ", ";\n"]);

var StyledLink = styled__default(span)(_templateObject, function (props) {
  return props.display ? props.display : "inline-block";
}, function (props) {
  return props.color ? props.color : settings.COLOR.brightBlue;
}, function (props) {
  return props.opacity && "opacity: " + props.opacity;
}, function (props) {
  return props.underline ? "underline" : "none";
}, function (props) {
  return props.hoverColor ? props.hoverColor : settings.COLOR.waterBlue;
}, function (props) {
  return props.hoverOpacity && "opacity: " + props.hoverOpacity;
}, function (props) {
  return props.underline || props.hoverUnderline ? "underline" : "none";
}, function (props) {
  return props.disabled && "color: " + settings.COLOR.lineGray + ";\n    pointer-events: none;";
});
var Link = function Link(_ref) {
  var text = _ref.text,
      children = _ref.children,
      rest = _babelHelpers.objectWithoutProperties(_ref, ["text", "children"]);
  return React__default.createElement(
    StyledLink,
    _babelHelpers._extends({}, rest, { as: "a" }),
    text && text,
    children && children
  );
};

Link.propTypes = {
  /** Link ID */
  id: PropTypes$1.string.isRequired,
  /** Link text */
  text: PropTypes$1.string,
  /** color of text  */
  color: PropTypes$1.string,
  /** font-weight of text  */
  weight: PropTypes$1.string,
  /** color of text on hover state */
  hoverColor: PropTypes$1.string,
  /** opacity of text */
  opacity: PropTypes$1.string,
  /** opacity of text on hover state */
  hoverOpacity: PropTypes$1.string,
  /** display underline text on default and hover state */
  underline: PropTypes$1.bool,
  /** display underline text on hover state */
  hoverUnderline: PropTypes$1.bool,
  /** disable link */
  disabled: PropTypes$1.bool
};

Link.defaultProps = {
  color: ""
};
Link.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Link",
  "props": {
    "color": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "color of text"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Link ID"
    },
    "text": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Link text"
    },
    "weight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "font-weight of text"
    },
    "hoverColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "color of text on hover state"
    },
    "opacity": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "opacity of text"
    },
    "hoverOpacity": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "opacity of text on hover state"
    },
    "underline": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "display underline text on default and hover state"
    },
    "hoverUnderline": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "display underline text on hover state"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "disable link"
    }
  }
};

exports.StyledLink = StyledLink;
exports.default = Link;
//# sourceMappingURL=link.js.map
